export default {
  themeforestNarrowItemCard: 'Xmwjnt6wR8mCSRXsMChfuw',
  codecanyonNarrowItemCard: '2oVLIOcfTLyg4g0mwqff0w',
  audioJungleNewItemCard: 'CS5D12vFR4-pLPI7nlkNXg',
  filesIncludedFilter: 'taqP_usUQIKuSBzJNzzPmQ'
}
